import React from 'react';
import { Link } from 'react-router-dom';
import { PALMISTRY_PRICE_LABEL } from '../../data/palmistry101Content';
import PalmistryPrimaryCta from './PalmistryPrimaryCta';

export default function PalmistryHero({ checkoutUrl, onPrimaryCta }) {
  return (
    <header className="amm-palmistry101-hero">
      <div className="amm-palmistry101-hero-inner">
        <p className="amm-palmistry101-eyebrow">Palmistry Mini-Course</p>
        <h1 className="amm-palmistry101-hero-title">Palmistry 101</h1>
        <p className="amm-palmistry101-hero-lead">
          A calm, practical introduction to reading the hand — from lines and mounts to pattern, timing,
          and interpretation.
        </p>
        <p className="amm-palmistry101-hero-support">
          Includes interactive on-page learning + downloadable PDF companion.
        </p>

        <div className="amm-palmistry101-hero-meta">
          <span className="amm-palmistry101-price">{PALMISTRY_PRICE_LABEL}</span>
          <span className="amm-palmistry101-meta-dot" aria-hidden />
          <span>Self-paced · beginner-friendly</span>
        </div>

        <div className="amm-palmistry101-badges" aria-label="Course highlights">
          <span className="amm-palmistry101-badge">Beginner-friendly</span>
          <span className="amm-palmistry101-badge">Self-paced</span>
          <span className="amm-palmistry101-badge">PDF included</span>
          <span className="amm-palmistry101-badge">Interactive hand study</span>
        </div>

        <div className="amm-palmistry101-hero-cta">
          <PalmistryPrimaryCta checkoutUrl={checkoutUrl} onFallback={onPrimaryCta} />
          <Link to="/courses" className="amm-palmistry101-btn amm-palmistry101-btn-ghost">
            All courses
          </Link>
        </div>
      </div>
    </header>
  );
}
